import { HomeTitle } from './base'

interface FeatureCardProps {
  icon: React.ReactNode
  title: string
}

const FeatureCard = ({ icon, title }: FeatureCardProps) => {
  return (
    <div className='flex items-center gap-4 shadow-md justify-start rounded-lg p-4 bg-white'>
      <div className='text-primary-500'>{icon}</div>
      <HomeTitle as='h3' size='feature' className='text-sm font-medium'>
        {title}
      </HomeTitle>
    </div>
  )
}

export default FeatureCard
